import { Container, ContainerProps } from '@mui/material'

const ZScreenContainer = (props: ContainerProps) => {
  const { children, style, ...rest } = props

  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '1rem',
        height: '100%',
        width: '100%',
        maxWidth: '430px',
        margin: '0 auto',
        paddingLeft: '5%',
        paddingRight: '5%',
        alignItems: 'center',
        ...style,
      }}
      {...rest}
    >
      {children}
    </Container>
  )
}

export default ZScreenContainer
